<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      size="medium"
      border
      stripe
    >
      <el-table-column
        label="STT"
        width="80"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'executing_at'">
            {{ scope.row.extra[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'action_id'">
            {{ scope.row.extra.action_id | actionName(allContractActions) }}
          </span>
          <span v-else-if="field.key === 'account_id'">
            {{ scope.row.extra.executing_user_id | accountName(accounts) }}
          </span>
          <span v-else>
            {{ scope.row.extra[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Nội dung chi tiết"
        width="200"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            icon="el-icon-document"
            type="primary"
            size="small"
            @click="() => handleDetail(scope.row)"
          >
            Xem chi tiết
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <RequestHistoryPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :document-data="[document]"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RequestHistoryPopup from "@/components/popups/RequestHistory.vue";

import extraServices from "@/services/extra";
import organizationServices from "@/services/organization";
import accountServices from "@/services/account";
import constants from "@/config/constants";
import { accountPer } from "@/utils/permission";

export default {
  name: "ApprovedHistory",
  components: {
    RequestHistoryPopup
  },
  props: {
    contractId: String,
    document: Object,
    showFast: Boolean,
  },
  data() {
    return {
      loading: false,
      data: [],
      accounts: [],
      selectedItem: null,
      formVisible: false,
      organizationId: organizationServices.getCurrentOrg()?.id,
      fileType: constants.FILE_TYPE,
      accountPer: accountPer()
    };
  },
  computed: {
    ...mapGetters("contract", ["allContracts", "allContractActions"]),
    params() {
      const _params = {
        offset: 0,
        limit: 100,
        locale: "vi",
        sort: "+created",
        filters: {
          organization_id: this.organizationId,
          type: null
        }
      };
      if (this.contractId) {
        _params.filters[`extra.contract_id`] = this.contractId
      }
      if (this.document) {
        _params.filters[`extra.document_id`] = this.document.id
      }
      return _params;
    },
    fields() {
      return [
        {
          key: "action_id",
          label: "Hành động",
        },
        {
          key: "notes",
          label: "Chi chú",
        },
        {
          key: "executing_at",
          label: "Thời gian",
        },
        {
          key: "account_id",
          label: "Người thực hiện",
        },
      ];
    },
  },
  async beforeMount() {
    await this.listData();
    if (this.accountPer.READ) {
      await this.listAllAccounts();
    }
    if (this.showFast) {
      this.handleDetail(this.data[this.data.length - 1]);
    }
  },
  methods: {
    async listData() {
      this.loading = true;
      await extraServices
        .list(this.params)
        .then(async (response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1,
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    async listAllAccounts() {
      await accountServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: this.organizationId,
      }).then((response) => {
        this.accounts = response.items.map((i) => ({
          id: i.id,
          email: i.email
        }))
      })
    },
    handleDetail(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleClose() {
      this.formVisible = false;
      this.$emit('close')
    }
  },
};
</script>

<style lang="scss"></style>
